import { type ConfigureOption } from "./types"

/**
 * Bare strings label themselves; pairs carry an opaque stored value.
 *
 * Shared rather than per-step: `ConfigureStep` and `ReviewStep` both take option
 * lists in the same union, and a second copy of this would be the place the two
 * quietly disagree about what a bare string means.
 */
export function optionPairs(
  options?: ConfigureOption[]
): { value: string; label: string }[] {
  return (options ?? []).map((option) =>
    typeof option === "string" ? { value: option, label: option } : option
  )
}
